import QueryString from 'qs';
import mainCaller from './mainCaller';

export const getAllChatMembers = async (token) => {
  return await mainCaller(`chat/api/v1/chat/members`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  }, 'CHAT');
}

export const getChatHistory = async (token, query) => {
  const queryString = QueryString.stringify(query)
  return await mainCaller(`chat/api/v1/chat/messages?${queryString}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  }, 'CHAT');
}

export const updateChatRoomClose = async (data,token) => {
  return await mainCaller(`chat/api/v1/chat/members/close`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
    "Content-type": "multipart/form-data"
  }, 'CHAT');
}